import { xs_languageCode } from "../..";
import { byRanking } from "./byRanking";
import { filterByCustomizedState } from "./filterByCustomizedState";
import { filterSportMenu } from "./filterSportMenu";
import { getFilters } from "./getFilters";
import { getLiveAggs } from "./getLiveAggs";
import { getPrematchAggs } from "./getPrematchAggs";
import { getRanking } from "./getRanking";
import { iconCategoryCssClass } from "./iconCategoryCssClass";

export function parseMenuData(data) {
    function parseTournaments(sportId, tournaments, iconClass, categoryIcon) {
        const aggregateById = getPrematchAggs(sportId);

        const filteredTournaments = filterByCustomizedState(tournaments);
        return filteredTournaments.map(function(tournament) {
            const aggregate = [];
            tournament.ags.forEach(aggId => {
                const agg = aggregateById[aggId];
                if (agg != null) {
                    aggregate.push(agg);
                }
            })
            aggregate.sort(byRanking);

            let liveData = null;
            if (tournament.lv) {
                const aggregate = [];
                tournament.ld.ags && tournament.ld.ags.forEach(ag => {
                    const agg = getLiveAggs(sportId, ag);
                    if (agg != null) {
                        aggregate.push(agg);
                    }
                })
                aggregate.sort(byRanking);

                liveData = {
                    aggregate,
                    eventsCount: tournament.ld.ne
                };
            }

            return {
                id: tournament.id,
                descrizione: tournament.dsl[xs_languageCode],
                ranking: getRanking(tournament),
                isLive: tournament.lv,
                eventsCount: tournament.ne,
                eventsCountByFilter: tournament.net,
                events: tournament.el || [],
                aggregate,
                liveData,
                iconClass,
                categoryIcon,
                filters: getFilters(tournament.tfs, tournament.lv),
                seoSettings: tournament.seo,
                seoSettingsAdds: tournament.seoa,
                ba: tournament.ba,
                seasonId: tournament.sid,
                betBuilder : tournament.bb
            };
        }).sort(byRanking);
    }

    function parseCategories(sportId, categories) {
        return filterByCustomizedState(categories).map(category => {
            const categoryIcon = iconCategoryCssClass(sportId, category.id, category.ic);
            const tournaments = parseTournaments(sportId, category.tns, category.ic, categoryIcon);

            return {
                id: category.id,
                descrizione: category.dsl[xs_languageCode],
                ranking: getRanking(category),
                isLive: category.lv,
                tournamentsCount: category.ne,
                tournamentsCountByFilter: category.net,
                tournaments,
                filters: getFilters(category.tfs, category.lv),
                iconClass: category.ic,
                categoryIcon,
                seoSettings: category.seo,
                seoSettingsAdds: category.seoa
            };
        }).sort(byRanking);
    }

    function parseSports(sports) {
        return filterByCustomizedState(sports).map(function(sport) {
            const categories = parseCategories(sport.id, sport.cts);

            return {
                id: sport.id,
                descrizione: sport.dsl[xs_languageCode],
                ranking: getRanking(sport),
                isLive: sport.lv,
                eventsCount: sport.ne,
                eventsCountByFilter: sport.net,
                categories,
                iconClass: sport.ic,
                filters: getFilters(sport.tfs, sport.lv),
                seoSettings: sport.seo,
                seoSettingsAdds: sport.seoa
            };
        }).sort(byRanking);
    }

    return parseSports(filterSportMenu(data));
}
